import React from "react";
import { Box, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

export const DonutChart: React.FC<{ data: { value: number, label: string, color: string, legendLabel: string; legendValue: string }[] }> = ({ data }) => {
    return (
        <Box display="flex" justifyContent="center" alignItems="center" height={'100%'}>
            <Box sx={{ width: "50%", height: '100%', overflow: 'hidden' }}>
                <PieChart
                    series={[{
                        data: data.map((item, index) => ({
                            id: index,
                            value: item.value,
                            label: item.label,
                            color: item.color,
                        })),
                        innerRadius: 50,
                        outerRadius: 100,
                        paddingAngle: 1,
                    }]}
                    margin={{ left: 0, right: 0, top: 0, bottom: 0 }}
                    slots={{ legend: () => null }}
                />
            </Box>
            <Box sx={{ width: "50%", height: '100%', overflowY: 'hidden' }} display="flex" flexDirection="column" justifyContent="center">
                <Box height={'85%'} mr={2} sx={{ overflowY: "auto", display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    {data.map((item, key: number) => (
                        <Box key={key} display="flex" alignItems="center" mb={0.8} gap={1}>
                            <Box
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    bgcolor: item.color,
                                }}
                            />
                            <Typography variant="caption" color="text.primary">
                                {item.label} :
                            </Typography>
                            <Typography
                                variant="caption"
                                color="text.primary"
                                fontWeight={500}
                            >
                                {item.legendValue}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};